export default [
  {
    header: 'Center',
    icon: 'ServerIcon',
    action: 'default',
    children: [
      {
        title: 'User Account',
        icon: 'UserIcon',
        route: 'user-account',
        action: 'default',
      },
    ],
  },
  {
    header: 'Management',
    icon: 'PackageIcon',
    resource: 'User',
    action: 'read',
    children: [
      {
        title: 'User',
        route: 'user-list',
        icon: 'UsersIcon',
        resource: 'User',
        action: 'read',
      },
    ],
  },
]
